import { Flex, Text } from "@/atoms"
import { ExternalLinkOutlined } from "@/icons"
import { LinkButton } from "@/molecules/LinkButton"
import { getAdminConsentUrl } from "@/pages/DeploymentsPage/application/useAgentPlatform.selector"
import { useAppRegistrationTranslation } from "./useAppRegistrationTranslation"

import type { AdminConsentProps } from "./AppRegistrationSteps.types"

// Kodem's app, which the threat detection token is for, enters the tenant
// once an admin consents to it
export const AdminConsent = ({ appId, azureTenantId }: AdminConsentProps) => {
  const t = useAppRegistrationTranslation()

  return (
    <Flex vertical gap={8} align="flex-start">
      <Text>{t("adminConsent")}</Text>
      <LinkButton
        href={getAdminConsentUrl(appId, azureTenantId)}
        target="_blank"
        icon={<ExternalLinkOutlined />}
      >
        {t("grantConsent")}
      </LinkButton>
    </Flex>
  )
}
